// Verified winners data supplied by organiser (sources: MC-Nytt, sportlexikon, Wikipedia).

export const RECENT = [
  { year: "2025", name: "Albin Elowson", club: "FMCK Skövde", place: "Vimmerby", note: "Fjärde karriärsegern – säkrade tävlingens 16:e vandringskåsa." },
  { year: "2024", name: "Niklas Persson", club: "Karlskoga EK", place: "Eksjö", note: "Andra raka segern, med drygt elva minuters marginal." },
  { year: "2023", name: "Niklas Persson", club: "Karlskoga EK", place: "Vimmerby", note: "Doldisens första seger – ca 40 sekunder före tvåan." },
];

// name, wins
export const LEGENDS = [
  { name: "Joakim Ljunggren", wins: 9, era: "2007–2019", extra: "Ensam rekordhållare – och ende med tre vandringskåsor." },
  { name: "Gunnar Kalén", wins: 6, era: "1926–1930" },
  { name: "Edvin Sagström", wins: 6, era: "1934–1936" },
  { name: "Svenerik Jönsson", wins: 6, era: "1981–1991" },
  { name: "Rolf Tibblin", wins: 5, era: "1960–1964", extra: "Fem raka segrar." },
  { name: "Hans Hansson", wins: 5, era: "1968–1976" },
  { name: "Erik Westerberg", wins: 4, era: "1920–1922" },
  { name: "Albin Elowson", wins: 4, era: "2017–2025", extra: "Mest framgångsrik aktiv förare." },
  { name: "Gunnar Johansson", wins: 3 },
  { name: "Torbjörn Jansson", wins: 3 },
  { name: "Kent Karlsson", wins: 3 },
  { name: "Joachim Hedendahl", wins: 3 },
  { name: "Anders Eriksson", wins: 3 },
  { name: "Mats Nilsson", wins: 3 },
];

// year -> winner (modern era). status: 'race' | 'none'. flag optional.
export const WINNERS = [
  { year: 1950, name: "Börje Nyström" },
  { year: 1951, name: "Lennart Carlström" },
  { year: 1952, name: "Elon Forsberg" },
  { year: 1953, name: "Lennart Carlström" },
  { year: 1954, name: "Bill Nilsson" },
  { year: 1955, name: "Gunnar Johansson & Roine Lööf" },
  { year: 1956, name: "Gunnar Johansson" },
  { year: 1957, name: "Karl-Erik Sjöblom" },
  { year: 1958, name: "Bill Nilsson" },
  { year: 1959, name: "Gunnar Johansson" },
  { year: 1960, name: "Rolf Tibblin" },
  { year: 1961, name: "Rolf Tibblin" },
  { year: 1962, name: "Rolf Tibblin" },
  { year: 1963, name: "Rolf Tibblin" },
  { year: 1964, name: "Rolf Tibblin" },
  { year: 1965, name: "Olle Pettersson" },
  { year: 1966, name: "Torsten Andersson" },
  { year: 1967, name: "Ingen tävling – högertrafikomläggningen", status: "none" },
  { year: 1968, name: "Hans Hansson" },
  { year: 1969, name: "Ingemar Österberg" },
  { year: 1970, name: "Hans Hansson" },
  { year: 1971, name: "Tommy Jansson" },
  { year: 1972, name: "Torbjörn Jansson" },
  { year: 1973, name: "Torbjörn Jansson" },
  { year: 1974, name: "Hans Hansson" },
  { year: 1975, name: "Hans Hansson" },
  { year: 1976, name: "Hans Hansson" },
  { year: 1977, name: "Torbjörn Jansson" },
  { year: 1978, name: "Ingemar Österberg" },
  { year: 1979, name: "Steve Tell" },
  { year: 1980, name: "Sune Strömberg" },
  { year: 1981, name: "Svenerik Jönsson" },
  { year: 1982, name: "Svenerik Jönsson" },
  { year: 1983, name: "Peter Hansson" },
  { year: 1984, name: "Per Grönberg" },
  { year: 1985, name: "Svenerik Jönsson" },
  { year: 1986, name: "Dick Wicksell" },
  { year: 1987, name: "Svenerik Jönsson" },
  { year: 1988, name: "Mikael Nilsson" },
  { year: 1989, name: "Håkan Lundberg" },
  { year: 1990, name: "Svenerik Jönsson" },
  { year: 1991, name: "Svenerik Jönsson" },
  { year: 1992, name: "Kent Karlsson" },
  { year: 1993, name: "Mika Ahola", flag: "🇫🇮" },
  { year: 1994, name: "Kent Karlsson" },
  { year: 1995, name: "Kent Karlsson" },
  { year: 1996, name: "Joachim Hedendahl" },
  { year: 1997, name: "Joachim Hedendahl" },
  { year: 1998, name: "Mika Ahola", flag: "🇫🇮" },
  { year: 1999, name: "Anders Eriksson" },
  { year: 2000, name: "Joachim Hedendahl" },
  { year: 2001, name: "Anders Eriksson" },
  { year: 2002, name: "Björne Carlsson / Stjernsten" },
  { year: 2003, name: "Anders Eriksson" },
  { year: 2004, name: "Mats Nilsson" },
  { year: 2005, name: "Mats Nilsson" },
  { year: 2006, name: "Mats Nilsson" },
  { year: 2007, name: "Joakim Ljunggren" },
  { year: 2008, name: "Carl-Johan \"Calle\" Bjerkert" },
  { year: 2009, name: "Joakim Ljunggren" },
  { year: 2010, name: "Joakim Ljunggren" },
  { year: 2011, name: "Jonas Bengtsson" },
  { year: 2012, name: "Joakim Ljunggren" },
  { year: 2013, name: "Joakim Ljunggren" },
  { year: 2014, name: "Joakim Ljunggren" },
  { year: 2015, name: "Joakim Ljunggren" },
  { year: 2016, name: "Joakim Ljunggren", place: "Knivsta", highlight: true, note: "8:e kåsasegern – senast Kåsan gick i Knivsta." },
  { year: 2017, name: "Albin Elowson" },
  { year: 2018, name: "Albin Elowson" },
  { year: 2019, name: "Joakim Ljunggren" },
  { year: 2020, name: "Inställd – Covid-19", status: "none" },
  { year: 2021, name: "Mikael Persson" },
  { year: 2022, name: "Albin Elowson" },
  { year: 2023, name: "Niklas Persson" },
  { year: 2024, name: "Niklas Persson" },
  { year: 2025, name: "Albin Elowson" },
];

export const EARLY_MILESTONES = [
  { year: "1915", text: "Gunnar Enderlein vinner den allra första kåsan på en Royal Enfield." },
  { year: "1920–22", text: "Erik Westerberg tar tre raka inteckningar." },
  { year: "1925", text: "Tävlingen avlyses efter snöstorm – Edvin Sagström ende i mål på förkortad bana." },
  { year: "1926–30", text: "Gunnar Kaléns dominans." },
  { year: "1934–36", text: "Edvin Sagströms era." },
  { year: "1937", text: "Folke Larsson." },
  { year: "1938", text: "Carl Hedelin." },
  { year: "1939–45", text: "Inga lopp under andra världskriget." },
  { year: "1946", text: "Bertil Carlsson." },
  { year: "1947", text: "Delad seger: Nils Andersson / Josef Koch." },
  { year: "1948", text: "Inget lopp." },
  { year: "1949", text: "Delad seger: Helge Brinkeback / Hans Danielsson." },
];
